export var PaymentItemProps = {
    system: {
        type: Object,
        required: true,
    },
    disabled: Boolean,
};
